<div class="tw-relative tw-overflow-scroll tw-h-full">
  @if (!loading) {
    @if(showNewHairReport || !isHairReport) {
      <div class="tw-font-body tw-bg-teal-200 tw-pt-4">
      <!-- Back Button -->
      @if (!isTimerPage) {
        <div class="tw-flex tw-absolute tw-top-2 tw-w-[40px] tw-h-[40px] tw-p-2 tw-justify-center tw-items-center tw-shrink-0 tw-rounded-xl tw-bg-black tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-mt-4 tw-ml-4 tw-z-10"
             (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
        </div>
      }
      <!-- Header -->
      <div class="tw-w-[90%] tw-mx-auto tw-flex tw-items-stretch tw-gap-5 tw-pb-11">
        <div class="tw-flex-1 tw-pt-[78px]">
          @if (isEnglishUser) {
            @if (isHairReport) {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize">{{userFirstName}}'s <br /> <span class="tw-inline-block tw-mt-1"> Hair Report </span></p>
            } @else {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize">{{userFirstName}}'s <br /> <span class="tw-inline-block tw-mt-1"> Skin Report </span></p>
            }
          } @else {
            @if (isHairReport) {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize" i18n="@@usernameHairReport">{{userFirstName}} <br /> <span class="tw-inline-block tw-mt-1"> Hair Report </span></p>
            } @else {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize" i18n="@@usernameSkinReport">{{userFirstName}} <br /> <span class="tw-inline-block tw-mt-1"> Skin Report </span></p>
            }
          }
          <div class="tw-opacity-10 tw-border tw-border-solid tw-border-black tw-mt-[14px]"></div>
          <div class="tw-font-bold tw-text-100 tw-mt-[9px] tw-mb-[14px]">
            @if (isHairReport) {
              <p class="tw-text-orange-400 tw-uppercase" i18n="@@yourHairSpecialist"> Your hair specialist </p>
            } @else {
              <p class="tw-text-orange-400 tw-uppercase" i18n="@@yourSkinSpecialist"> Your skin specialist </p>
            }
            <p class="tw-text-black">{{allocatedDoctor?.get('DoctorDisplayName')}}</p>
          </div>
        </div>
        <div class="tw-flex-1 tw-max-w-[42%] tw-flex tw-items-end">
          <img class="tw-object-contain tw-w-full tw-h-auto" [src]="allocatedDoctor?.get('DoctorImageThumbnail')" alt="doctor" />
        </div>
      </div>
      <div class="font-noto tw-rounded-3xl tw-bg-gray-80">
        <section class="tw-bg-gray-80 tw-w-full tw-rounded-tl-5 tw-rounded-tr-5">
          <div class="tw-w-[90%] tw-mx-auto tw-pt-5 tw-pb-4 tw-shadow-z4 tw-rounded-[10px] tw-relative -tw-top-11 tw-font-lexend tw-bg-white">
            <div class="tw-mx-4">
              <ng-container *ngTemplateOutlet="concernsTemplate"></ng-container>
            </div>
          </div>
          <!-- Overall Summary -->
          <div class="tw-flex tw-justify-space-around tw-gap-4 tw-items-start tw-mx-4 -tw-mt-4 tw-mb-6">
            @if (previousInstantCheckup?.[0]?.['imagePath']) {
              <img class="w40 tw-object-contain tw-h-50" [src]="previousInstantCheckup[0]['imagePath']" />
            }
            @if(overallSummary) {
              <div>
                <div [ngClass]="brandFontClass" class="tw-text-300 tw-text-gray-800 tw-font-bold tw-uppercase" i18n="@@reportOverallSummaryLabel">Overall Summary</div>
                <div class="tw-text-300 tw-text-gray-500">
                  {{ overallSummary }}
                </div>
              </div>
            }
          </div>
          @if (showRebrandedSkinParameters) {
            <rebranded-report-parameter [skinParametersInfo]="skinParametersInfo" [isHairReport]="isHairReport"></rebranded-report-parameter>
          } @else if (hasParameterData) {
            <div [ngClass]="brandFontClass"
                  class="tw-text-300 tw-text-gray-800 tw-font-bold tw-uppercase tw-mx-4 tw-mt-6">
              @if (isHairReport) {
                Your key hair parameters
              } @else {
                Your key skin parameters
              }
            </div>
            <div class="tw-overflow-x-scroll tw-flex tw-gap-x-2.5 tw-pt-4 tw-pb-6">
              <div class="tw-flex">
                @for (card of activeParameterCards; track card.severityKey) {
                  @if (skinParametersInfo?.[card.paramKey]?.patientScore && skinParametersInfo?.[card.paramKey]?.expectedRange) {
                    <div class="tw-relative first:tw-ml-4 last:tw-mr-4 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-flex-col tw-rounded-lg tw-mr-2 tw-pb-[18vh] tw-bg-white">
                      @if (severityIconDisplayMap[card.severityKey]) {
                        <cs-icon class="tw-absolute -tw-top-[12px] tw-ml-4 tw-w-6 tw-h-6 tw-rounded-[50%] tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]"
                                 [iconName]="'/rebranding/v1/exclamation_icon'"></cs-icon>
                      }
                      <div [ngClass]="brandFontClass"
                           class="tw-text-500 tw-text-gray-800 tw-font-bold tw-mt-6 tw-mx-4 tw-mb-2"
                           [innerHTML]="card.title"></div>
                      <div class="tw-text-200 tw-font-normal tw-text-gray-500 tw-w-[184px] tw-mx-4">
                        {{card.description}}
                      </div>
                      <skin-parameter [patientScore]="skinParametersInfo?.[card.paramKey]?.patientScore"
                                      [expectedRange]="skinParametersInfo?.[card.paramKey]?.expectedRange"
                                      (showExclamationIcon)="setSeverityIconDisplayState(card.severityKey, $event)"></skin-parameter>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (drVideoExpAssets) {
            <section class="tw-mb-4">
              <h1 class="tw-font-body tw-font-bold tw-text-500 tw-text-gray-800 tw-ml-4 tw-mb-3"
                  i18n="@@whatYouCanExpect">What you can expect</h1>
              <div class="tw-flex tw-gap-2 tw-items-center tw-overflow-y-auto tw-pl-4">
                @for (video of drVideoExpAssets.video; track $index) {
                  <div class="tw-w-2/5 tw-shrink-0">
                    <app-floating-video-panel [url]="video"></app-floating-video-panel>
                  </div>
                }
                @for (image of drVideoExpAssets.images; track $index) {
                  <div class="tw-w-2/5 tw-shrink-0 tw-overflow-hidden">
                    <img class="tw-object-cover tw-h-full tw-w-full tw-object-center"
                         [src]="image"
                         alt="report" />
                  </div>
                }
              </div>
            </section>
          }
          @if (showRootCausesBanner) {
            <app-root-cause-banner [rootCauses]="rootCauses" [changeHeading]="showArrowUIRootCauses"></app-root-cause-banner>
          }
          <!-- Treatment Plan -->
          @if (showTreatmentPlan) {
            <app-report-treatment-plan
              [showArrowUI]="showRootCausesBanner && showArrowUIRootCauses"
              [displayConcern]="resolvedConcernName"
              [languagePreference]="user?.get('languagePreference')"
              [allocatedDoctorImage]="allocatedDoctor?.get('doctorDisplayImage')"
              [regimen]="regimen"
              [experiment]="experimentService.treatmentPlanDescriptionExperiment.variant">
            </app-report-treatment-plan>
          }
          <!-- Hero Ingredients / Improvement Journey -->
          @if (showHeroIngredients && (!showTreatmentPlan || experimentService.treatmentPlanDescriptionExperiment?.variant?.showHeroIngredients)) {
            <hero-ingredients [acqRebranding2025]="experimentService.acqRebranding2025"
                              [heroIngredients]="heroIngredients"
                              [doctorDisplayImage]="allocatedDoctor?.get('doctorDisplayImage')"
                              [isRebrandedHeroIngredients]="isRebrandedHeroIngredients"
                              [isHairReport]="isHairReport"></hero-ingredients>
          } @else if (!showTreatmentPlan && !showHeroIngredients) {
            <improvement-journey [showFirstJourney]="showFirstJourney"
                                 [doctorDisplayImage]="allocatedDoctor?.get('doctorDisplayImage')"></improvement-journey>
          }
        </section>
        <testimonial-wall [regimen]="regimen"
                          [acqRebranding2025]="experimentService.acqRebranding2025"></testimonial-wall>
        <div class="tw-bg-white tw-ml-auto tw-mr-auto tw-px-4 tw-pb-10 tw-pt-6">
          <div class="tw-text-200 tw-text-gray-800">
            1. Cureskin dermatologist follow the American Association of Dermatology,
            European association of Dermatology and IADVL guidelines to ensure the
            best and latest practices are adopted for identifying and treating your
            skin problems.
          </div>
          <div class="tw-text-200 tw-mt-2 tw-text-gray-800">
            2. Active ingredients in Cureskin prescription products are supported by
            clinical trial evidence and have secured FDA approval.
          </div>
          <div class="tw-flex tw-flex-col tw-mt-8 tw-justify-center">
            <img class="tw-w-[150px]"
                 src="https://cdn.cureskin.com/app/img/dr-charu-sign.png"
                 alt="doctor" />
            <div class="tw-text-200 tw-text-gray-800">Head of Dermatology</div>
          </div>
          <div class="tw-border-b tw-border-gray-300 tw-mt-8 tw-mb-2"></div>
          <div class="tw-flex tw-justify-between"
               [style.paddingBottom]="showRegimenToast ? '80px' : '0'">
            <div class="tw-text-100 tw-uppercase tw-pb-5 tw-text-gray-800">End of report</div>
            <cs-icon class="tw-w-[38px] tw-h-[12px]"
                     [iconName]="'cs-logo'"></cs-icon>
          </div>
        </div>
      </div>
    </div>
    } @else {
      <ng-container *ngIf="isHairReport">
        @if (!isTimerPage) {
          <div class="tw-flex tw-absolute tw-top-2 tw-w-[40px] tw-h-[40px] tw-p-2 tw-justify-center tw-items-center tw-shrink-0 tw-rounded-xl tw-bg-black tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-mt-4 tw-ml-4 tw-z-10"
               (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
          </div>
        }
        <div class="tw-text-800 tw-text-gray-800 tw-bg-purple-200 tw-bg-grid-layout tw-bg-repeat-x tw-font-bold tw-pt-24 tw-px-4 tw-pb-4 tw-font-body"
             i18n="@@yourHairReport">Your Hair Report</div>
        <div class="font-noto tw-bg-gray-80">
          <section class="tw-bg-gray-80 tw-w-full tw-rounded-tl-5 tw-rounded-tr-5 tw-pt-6">
            <section *ngIf="allocatedDoctor"
                     class="tw-mx-4 tw-mb-6 tw-py-4 tw-bg-white tw-rounded-xl tw-shadow-z1 tw-relative tw-z-0 tw-overflow-hidden">
              <div class="tw-z-10 tw-relative">
                <div class="tw-px-4 tw-py-2 tw-mb-3 tw-bg-orange-100 tw-rounded-tr-lg tw-rounded-br-lg tw-w-content tw-flex tw-flex-row tw-items-center tw-gap-2">
                  <cs-icon class="tw-w-5 tw-h-5 tw-text-orange-500"
                           [iconName]="'check_circle'"></cs-icon>
                  <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-400"
                     i18n="@@yourHairSpecialist"> Your hair specialist </p>
                </div>
                <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-px-4 tw-justify-between">
                  <div>
                    <h2 class="tw-font-body tw-font-bold tw-text-500 tw-text-gray-900 tw-mb-1">
                      {{allocatedDoctor?.get('DoctorDisplayName')}}
                    </h2>
                    <p class="tw-font-body tw-text-300 tw-text-gray-400 tw-mb-2">
                      {{conn.getQualifyText(allocatedDoctor)}}
                    </p>
                    <p class="tw-font-body tw-font-bold tw-text-200 tw-text-gray-900"
                       i18n="@@noOfCureskinPatientTreatedSoFar"> Has treated {{allocatedDoctor?.get('patientsTreated') || 0}}+
                      <br />Cureskin patients </p>
                  </div>
                  <img class="tw-flex-none tw-h-28 tw-w-28 tw-rounded-full tw-bg-green-100 tw-object-contain"
                       *ngIf="allocatedDoctor?.get('DoctorImageThumbnail')"
                       [src]="allocatedDoctor.get('doctorDisplayImage')"
                       alt="Doctor" />
                </div>
              </div>
            </section>
            <section class="tw-mb-4 tw-mx-4">
              <p class="tw-font-body tw-text-300 tw-text-gray-900 tw-mb-3"
                 i18n="@@fourStepHairCareNew"> Given your hair concerns, we are creating a <span class="bolder"> hair treatment
            kit for you.</span><span> The customized kit contains products with specific ingredients to suit your hair type and needs.</span></p>
              <ul class="tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-4 tw-pt-4"
                  *ngIf="regimen?.regimenTag">
                <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-2"
                    *ngFor="let item of regimen.regimenTag">
                  <img class="tw-h-16 tw-w-16 tw-object-contain"
                       [src]="item?.rebrandedImage"
                       alt="regimen" />
                  <p class="tw-font-body tw-text-300 tw-text-gray-900 tw-text-center tw-capitalize">
                    {{ item.title }}
                  </p>
                </li>
              </ul>
            </section>
            <testimonial-wall [regimen]="regimen"
                              [acqRebranding2025]="false"
                              ></testimonial-wall>
            <div class="tw-bg-white tw-ml-auto tw-mr-auto tw-px-4 tw-pb-10 tw-pt-6">
              <div class="tw-border-b tw-border-gray-300 tw-mt-8 tw-mb-2"></div>
              <div class="tw-flex tw-justify-between">
                <div class="tw-text-100 tw-uppercase tw-pb-5 tw-text-gray-800">End of report</div>
                <cs-icon class="tw-w-[38px] tw-h-[12px]"
                         [iconName]="'cs-logo'"></cs-icon>
              </div>
            </div>
          </section>
        </div>
      </ng-container>
    }
  }
  <ng-template #concernsTemplate>
    <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
      @if (isHairReport) {
        <span class="tw-font-normal" i18n="@@reportPrimaryConcernLabel">Primary concern:</span>
      } @else {
        <span class="tw-font-normal" i18n="@@reportMainConcernLabel">Main concern:</span>
      }
      <span class="tw-font-bold tw-inline-block first-letter:tw-uppercase">&nbsp;{{ resolvedConcernName }}</span>
    </p>
    @if (otherConcerns.length > 0) {
      <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
        @if (isHairReport) {
          <span class="tw-font-normal" i18n="@@reportSecondaryConcernLabel">Secondary concern: <span class="bolder"> {{ otherConcerns }}</span></span>
        } @else {
          <span class="tw-font-normal" i18n="@@reportOtherConcernsLabel">Other concerns: <span class="bolder"> {{ otherConcerns }}</span></span>
        }
      </p>
    }
    <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
      <span class="tw-font-normal">
        <span i18n="@@reportSeverityLabel">Severity:</span>
        <span class="bolder">&nbsp;</span>
        <span class="bolder">{{severity}}</span>
      </span>
    </p>
  </ng-template>
</div>
